import Avatar from 'components/base/Avatar';
import { Button, Card, Dropdown, Form, Modal, Nav } from 'react-bootstrap';
import avatar from 'assets/img/team/72x72/57.webp';
import FeatherIcon from 'feather-icons-react';
import { Link, useNavigate } from 'react-router-dom';
import classNames from 'classnames';
import { logoutUser } from 'Api/userapi';
import { toast } from 'react-hot-toast';
import { useState } from 'react';
import { RootState } from './../../../store';
import { useSelector } from 'react-redux';

const ProfileDropdownMenu = ({ className }: { className?: string }) => {
  const { user } = useSelector((state: RootState) => state.auth);
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();
  const handleLogout = async () => {
    try {
      const response = await logoutUser();
      if (response.status === 200) {
        navigate('/Homepage');
        setTimeout(() => {
          toast.success(`${response.data.message}`);
        }, 500);
      }
    } catch (error) {
      console.error('Logout failed:', error);
      toast.error('Logout failed. Please try again.');
    }
  };

  const handleShowModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);
  return (
    <>
      <Dropdown.Menu
        align="end"
        className={classNames(
          className,
          'navbar-top-dropdown-menu navbar-dropdown-caret py-0 dropdown-profile shadow border'
        )}
      >
        <Card className="position-relative border-0">
          <Card.Body className="p-0">
            <div className="d-flex flex-column align-items-center justify-content-center gap-2 pt-4 pb-3">
              <Avatar src={avatar} size="xl" />
              <h6 className="text-body-emphasis">
                {user.firstName} {user.lastName}
              </h6>
            </div>
          </Card.Body>

          <hr />
          <div className="px-3">
            <div
              className="btn btn-phoenix-secondary d-flex flex-center w-100"
              onClick={handleShowModal}
            >
              <FeatherIcon icon="log-out" className="me-2" size={16} />
              Sign out
            </div>
          </div>

          <div className="my-2 text-center fw-bold fs-10 text-body-quaternary"></div>
        </Card>
      </Dropdown.Menu>

      <Modal show={showModal} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Logout</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure you want to log out?</Modal.Body>
        <Modal.Footer>
          <Button
            variant="primary"
            onClick={() => {
              handleLogout();
              handleCloseModal();
            }}
          >
            Confirm
          </Button>
          <Button variant="phoenix-primary" onClick={handleCloseModal}>
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ProfileDropdownMenu;
